import React from 'react';
import { Route, Switch } from 'react-router';

export const RouteMapRoutes = ({ routeMap }) => (
    <Switch>
        {Object.keys(routeMap).map(page => (
            <Route
                key={routeMap[page].path}
                path={routeMap[page].path}
                render={routeMap[page].render}
                exact={routeMap[page].exact}
                strict={routeMap[page].strict}
            />
        ))}
    </Switch>
);
